import React from "react";
import { Layers } from "lucide-react";
import { GALLERY_PLACEHOLDER } from "../../config/downloads";

/**
 * Elegant engineering placeholder for product imagery.
 * Never uses stock photos pretending to be DEBSUN products.
 */
export default function ProductGalleryPlaceholder({
  compact = false,
  label = GALLERY_PLACEHOLDER.title,
  className = "",
}) {
  return (
    <div
      className={`relative flex flex-col items-center justify-center text-center border border-border bg-secondary/50 overflow-hidden ${
        compact ? "aspect-[4/3] p-6" : "aspect-[4/3] p-10"
      } ${className}`}
      data-testid="product-gallery-placeholder"
      role="img"
      aria-label={`${label} — coming soon`}
    >
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(to right, var(--steel) 1px, transparent 1px), linear-gradient(to bottom, var(--steel) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
        aria-hidden="true"
      />
      <Layers
        size={compact ? 28 : 36}
        strokeWidth={1.2}
        className="relative text-[color:var(--gold)] mb-4"
        aria-hidden="true"
      />
      <div className="relative font-mono-2 text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-2">
        {label}
      </div>
      <div
        className="relative font-mono-2 text-sm tracking-[0.25em] uppercase"
        style={{ color: "var(--gold)" }}
      >
        {GALLERY_PLACEHOLDER.status}
      </div>
      {!compact && (
        <p className="relative mt-4 text-xs text-steel-text leading-relaxed max-w-sm">
          {GALLERY_PLACEHOLDER.description}
        </p>
      )}
    </div>
  );
}
